import {
  ProjectBreakdownClient,
  ClientOutput,
} from '../../Clients/ProjectBreakdownClient';
import { call, put } from 'redux-saga/effects';
import { ApiGetter } from '../../Clients/ApiGetter';
import { actions } from '../../../reducers/ProjectDashboard/ProjectBreakdown';

export const projectBreakdownClient = new ProjectBreakdownClient(
  new ApiGetter()
);

interface GetProjectBreakdownAction {
  repositoryUUID: string;
}

export function* getProjectBreakdown({
  repositoryUUID,
}: GetProjectBreakdownAction) {
  const { data, error }: ClientOutput = yield call(
    [projectBreakdownClient, projectBreakdownClient.retrieveAsync],
    repositoryUUID
  );

  if (error || !data) {
    yield put(actions.setProjectBreakdown(undefined));
    return;
  }

  yield put(actions.setProjectBreakdown(data));
}
